import React, { createRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import { message, notification, Form } from "antd";
import Layout from "components/layout";
import ReleaseVehicleAction from "components/releaseVehicleAction";
import { bindActionCreators } from "redux";
import { Creators as AttendanceActions } from "store/attendance/attendance-duck";
import { ISummaryData, IVehicleStatusList, IAttendanceItems } from "store/attendance/attendance-model";
import { Creators as LobbyActions } from "store/lobby/lobby-duck";
import {
  IDocumentsData,
  IDocumentType,
  IProcessesData,
  IRegisterActiveItem,
  IRegisterCheckinItem,
  ISaleChannelData,
  IVehicleProfileByPlate,
  PlateFormatType,
} from "store/lobby/lobby-model";
import { Creators as ProcessActiona } from "store/process/process-duck";
import { Creators as UserSessionActions } from "store/user-session/user-session-duck";
import { IUserData, MenuItemActive } from "store/user-session/user-session-model";
import { IEventsVehicleHistory } from "typings/global";
import { DrawerStatusEnum, TabPaneStatusEnum } from "typings/global.types";
import TokenService from "utils/auth/Token.service";
import { formattedDateNow, isAttendanceAndAdmin, setCookiesCurrentPage } from "utils/functions";
import useTranslation from "utils/hooks/useTranslation";
import {
  onConfirmDrawerCheckinRegister,
  onConfirmDrawerViewRegister,
  onConfirmExcludeCheckinRegister,
  onConfirmReleaseVehicleAction,
  onConfirmVehicleAction,
} from "./attendance.service";
import AttendanceFilter from "./components/filter";
import FilterOptions from "./components/filterOptions";
import { Register } from "./components/register";
import Summary from "./components/summary";
import VehicleAction from "./components/VehicleAction";
import Drawers from "./Drawers";
import AttendanceGrid from "./grid/index";
import * as S from "./styled/screen.styled";

interface IPropsScreenAttendance {
  isLoading?: boolean;
  isConcierge?: boolean;
  disabledButtonReleaseVehicle?: boolean;
  items?: Array<IAttendanceItems>;
  totalItems?: number;
  pageIndex?: number;
  userData?: IUserData;
  salesChannelList?: Array<ISaleChannelData>;
  documentsList?: Array<IDocumentsData>;
  inboundProcessesList?: Array<IProcessesData>;
  formViewOrEditModified?: boolean;
  registerActive?: IRegisterActiveItem;
  hasScheduling?: boolean;
  allowRequestDockEntryAction?: boolean;
  allowRequestVehicleInboundAction?: boolean;
  allowRequestVehicleEntryAuthorizationAction?: boolean;
  visibleModalVehicleAction?: boolean;
  visibleDrawerViewCheckinRegisterAttendance?: boolean;
  visibleDrawerCheckinRegisterAttendance?: boolean;
  visibleModalReleaseVehicle?: boolean;
  visibleDrawerViewMode?: DrawerStatusEnum;
  visibleDrawerVehicleEntryAuthorization?: boolean;
  searchFilter?: string;
  hasSaleChannel?: boolean;
  checkinRegisterActive?: IRegisterCheckinItem;
  processActive?: number;
  saleChannelActive?: number;
  disabledButton?: boolean;
  disabledButtonSaveVehicle?: boolean;
  excludeButtonDisabled?: boolean;
  vehicleEntryAuthorizationRegisterActive?: Array<IEventsVehicleHistory>;
  activeSummaryData?: ISummaryData;
  isCollapseSidebar?: boolean;
  isLoadingTable?: boolean;
  isLoadingSummary?: boolean;
  visibleDrawerViewRegisterAttendance?: boolean;
  vehicleStatusList?: Array<IVehicleStatusList>;
  tabPaneActive?: TabPaneStatusEnum;
  drawerIsLoading?: boolean;
  documentType?: IDocumentType;
  plateFormatType?: PlateFormatType;
  vehicleProfileByPlate?: IVehicleProfileByPlate | null;
}

interface IDispatchProps {
  lobbyInboundProcessesFetchAsync?: (...args) => void;
  lobbyDocumentsFetchAsync?: (...args) => void;
  lobbySaleChannelsFetchAsync?: (...args) => void;
  lobbyFetchItemCheckinAsync?: (...args) => void;
  lobbyCheckinUpdateRegisterActive?: (...args) => void;
  lobbyProcessActive?: (...args) => void;
  lobbySaleChannelActive?: (...args) => void;
  attendanceFetchRegisterAsync?: (...args) => void;
  attendanceUpdateDrawerViewMode?: (...args) => void;
  attendanceUpdateFormModified?: (...args) => void;
  attendanceChangeFieldValue?: (...args) => void;
  attendanceShowModalVehicleAction?: () => void;
  attendanceHideModalVehicleAction?: () => void;
  attendanceSaveVehicleActionAsync?: (...args) => void;
  attendanceShowDrawerViewCheckinRegister?: (...args) => void;
  attendanceHideDrawerViewCheckinRegister?: (...args) => void;
  attendanceUpdateFilterTable?: (...args) => void;
  attendanceUpdateInboundAsync?: (...args) => void;
  attendanceHideDrawerVehicleEntryAuthorization?: (...args) => void;
  attendanceHideModalReleaseVehicleAction?: (...args) => void;
  attendanceShowModalReleaseVehicleAction?: (...args) => void;
  attendanceSaveReleaseVehicleActionAsync?: (...args) => void;
  attendanceShowDrawerCheckinRegister?: (...args) => void;
  attendanceHideDrawerCheckinRegister?: (...args) => void;
  attendanceShowDrawerViewRegister?: (...args) => void;
  attendanceSaveCheckinRegisterAsync?: (...args) => void;
  attendanceRemoveCheckinRegisterAsync?: (...args) => void;
  attendanceUpdateCheckinAsync?: (...args) => void;
  lobbyClearDocuments?: (...args) => void;
  attendanceChangeFilterOptionsValue?: (...args) => void;
  attendanceShowDrawerVehicleEntryAuthorization?: (...args) => void;
  attendanceFetchItemVehicleEntryAuthorizationAsync?: (...args) => void;
  attendanceFetchSummaryAsync?: (...args) => void;
  attendanceUpdateEventTypeTable?: (...args) => void;
  attendanceUpdateTabpaneActive?: (...args) => void;
  lobbyFetchItemAsync?: (...args) => void;
  attendanceUpdateItemsCheckin?: (...args) => void;
  userSessionMenuItemActive?: (...args) => void;
  processFetchAllProcessesAsync?: () => void;
  attendanceFetchVehicleStatusAsync?: () => void;
  attendanceHideDrawerViewRegister?: () => void;
  lobbyCheckinClearDrivers?: () => void;
  lobbyFetchVehicleProfileByPlateAsync?: (...args) => void;
  lobbyUpdateVehicleProfileByPlate?: (...args) => void;
}

export type IAttendanceProps = IPropsScreenAttendance & IDispatchProps;

const Attendance = ({
  isLoading,
  drawerIsLoading,
  isConcierge,
  excludeButtonDisabled,
  disabledButtonReleaseVehicle,
  items,
  totalItems,
  pageIndex,
  userData,
  hasSaleChannel,
  registerActive,
  documentsList,
  salesChannelList,
  inboundProcessesList,
  allowRequestDockEntryAction,
  allowRequestVehicleInboundAction,
  allowRequestVehicleEntryAuthorizationAction,
  visibleModalVehicleAction,
  visibleDrawerViewCheckinRegisterAttendance,
  visibleDrawerVehicleEntryAuthorization,
  visibleDrawerCheckinRegisterAttendance,
  searchFilter,
  visibleModalReleaseVehicle,
  checkinRegisterActive,
  processActive,
  saleChannelActive,
  disabledButton,
  disabledButtonSaveVehicle,
  visibleDrawerViewMode,
  formViewOrEditModified,
  vehicleEntryAuthorizationRegisterActive,
  activeSummaryData,
  isCollapseSidebar,
  isLoadingTable,
  isLoadingSummary,
  vehicleStatusList,
  visibleDrawerViewRegisterAttendance,
  tabPaneActive,
  hasScheduling,
  documentType,
  plateFormatType,
  vehicleProfileByPlate,
  lobbySaleChannelActive,
  attendanceHideDrawerViewRegister,
  attendanceUpdateDrawerViewMode,
  lobbyInboundProcessesFetchAsync,
  lobbyFetchItemCheckinAsync,
  lobbyCheckinUpdateRegisterActive,
  lobbyDocumentsFetchAsync,
  lobbyClearDocuments,
  lobbyProcessActive,
  lobbySaleChannelsFetchAsync,
  attendanceFetchRegisterAsync,
  attendanceChangeFieldValue,
  attendanceUpdateFormModified,
  attendanceHideDrawerVehicleEntryAuthorization,
  attendanceShowModalVehicleAction,
  attendanceHideModalVehicleAction,
  attendanceSaveVehicleActionAsync,
  attendanceShowDrawerViewCheckinRegister,
  attendanceHideDrawerViewCheckinRegister,
  attendanceUpdateFilterTable,
  attendanceHideModalReleaseVehicleAction,
  attendanceShowModalReleaseVehicleAction,
  attendanceSaveReleaseVehicleActionAsync,
  attendanceHideDrawerCheckinRegister,
  attendanceShowDrawerCheckinRegister,
  attendanceShowDrawerViewRegister,
  attendanceSaveCheckinRegisterAsync,
  attendanceRemoveCheckinRegisterAsync,
  attendanceUpdateCheckinAsync,
  attendanceShowDrawerVehicleEntryAuthorization,
  attendanceFetchItemVehicleEntryAuthorizationAsync,
  attendanceFetchSummaryAsync,
  attendanceChangeFilterOptionsValue,
  attendanceFetchVehicleStatusAsync,
  attendanceUpdateTabpaneActive,
  lobbyFetchItemAsync,
  attendanceUpdateInboundAsync,
  attendanceUpdateItemsCheckin,
  userSessionMenuItemActive,
  lobbyCheckinClearDrivers,
  lobbyFetchVehicleProfileByPlateAsync,
  lobbyUpdateVehicleProfileByPlate,
}: IAttendanceProps) => {
  const tokenService = new TokenService();
  const INTERVAL_MINUTES = 60000;
  const TITLE_PAGE = useTranslation({ id: "attendance" });
  const REQUIRED_FIELDS_MESSAGE = useTranslation({ id: "required_fields_are_required" });
  const EXCLUDE_CHECKIN_ERROR = useTranslation({ id: "exclude_checkin_error" });
  const FILL_IN_THE_FIELDS_CORRECTLY_MESSAGE = useTranslation({ id: "fill_in_the_fields_correctly" });
  const VALIDATE_DUPLICATE_DOCUMENTS_MESSAGE = useTranslation({ id: "validate_duplicate_documents" });
  const [form] = Form.useForm();
  const [formCheckin] = Form.useForm();
  const [formVehicleActionAttendance] = Form.useForm();
  const [gateEventId, setGateEventId] = useState(null);
  const [yardRegisterId, setYardRegisterId] = useState(null);
  const [vehicleActionSelected, setVehicleActionSelected] = useState(1);
  const [vehiclePlateSelected, setVehiclePlateSelected] = useState(null);
  const [statusId, setStatusId] = useState(0);
  const [processValue, setProcessValue] = useState([]);
  const [salesChannelvalue, setSalesChannelValue] = useState([]);
  const YES_MESSAGE = useTranslation({ id: "yes" });
  const NO_MESSAGE = useTranslation({ id: "no" });
  const eventTime = formattedDateNow();
  const carrierRef = createRef<HTMLDivElement>();
  const checkIfHasSaleChannelIsActive = hasSaleChannel ? saleChannelActive : null;
  const visibleFocus = () => visibleDrawerCheckinRegisterAttendance && carrierRef.current.focus();
  const intervalCallApi = () => {
    attendanceFetchRegisterAsync();
    attendanceFetchSummaryAsync();
  };

  useEffect(() => {
    userSessionMenuItemActive(MenuItemActive.ATTENDANCE);
    tokenService.authenticateToken();
  }, []);

  useEffect(() => {
    return () => {
      attendanceUpdateFilterTable(null);
      attendanceChangeFilterOptionsValue("processId", []);
      attendanceChangeFilterOptionsValue("saleChannelId", []);
      attendanceChangeFilterOptionsValue("status", null);
      setCookiesCurrentPage("attendance");
    };
  }, []);

  useEffect(() => {
    if (registerActive?.yardRegisterId) {
      form.setFieldsValue(registerActive);
    }
  }, [registerActive]);

  useEffect(() => {
    intervalCallApi();
    const timer = setInterval(() => intervalCallApi(), INTERVAL_MINUTES);
    return () => {
      clearInterval(timer);
      notification.destroy();
    };
  }, []);

  useEffect(() => {
    lobbyInboundProcessesFetchAsync();
    lobbySaleChannelsFetchAsync();
    attendanceFetchVehicleStatusAsync();
  }, []);

  useEffect(() => {
    if (searchFilter !== "" || searchFilter === null) {
      attendanceChangeFieldValue("pageIndex", 1);
      attendanceFetchRegisterAsync();
    }
  }, [searchFilter]);

  const onChangeRadioVehicleAction = (e) => {
    setVehicleActionSelected(e.target.value);
  };

  const handleOnConfirmDrawerViewRegister = () => {
    onConfirmDrawerViewRegister({
      visibleDrawerViewMode,
      eventTime,
      attendanceUpdateDrawerViewMode,
      form: form,
      attendanceUpdateCheckinAsync,
      message,
      messageDescription: FILL_IN_THE_FIELDS_CORRECTLY_MESSAGE,
      messageErrorDuplicateDocuments: VALIDATE_DUPLICATE_DOCUMENTS_MESSAGE,
      documents: documentsList,
      inboundProcessesList,
      userData,
      processActive,
      saleChannelActive: checkIfHasSaleChannelIsActive,
      salesChannelList,
      checkinRegisterActive,
      attendanceUpdateInboundAsync,
    });
  };

  const handleClickConfirmVehicleAction = () => {
    onConfirmVehicleAction({
      form: formVehicleActionAttendance,
      id: gateEventId,
      message,
      messageDescription: REQUIRED_FIELDS_MESSAGE,
      vehicleActionSelected,
      attendanceSaveVehicleActionAsync,
    });
  };

  const handleClickConfirmReleaseVehicleAction = () => {
    onConfirmReleaseVehicleAction({
      id: yardRegisterId,
      attendanceSaveReleaseVehicleActionAsync,
    });
  };

  const handleOnConfirmDrawerCheckinRegister = () =>
    onConfirmDrawerCheckinRegister({
      form: formCheckin,
      eventTime,
      userData,
      attendanceSaveCheckinRegisterAsync,
      message,
      messageDescription: REQUIRED_FIELDS_MESSAGE,
      messageErrorDuplicateDocuments: VALIDATE_DUPLICATE_DOCUMENTS_MESSAGE,
      documents: documentsList,
      checkinRegisterActive,
      inboundProcessesList,
      processActive,
      saleChannelActive,
      salesChannelList,
    });

  const handleOnConfirmExcludeCheckin = () => {
    onConfirmExcludeCheckinRegister({
      checkinRegisterActive: checkinRegisterActive,
      message: message,
      messageDescription: EXCLUDE_CHECKIN_ERROR,
      attendanceRemoveCheckinRegisterAsync: attendanceRemoveCheckinRegisterAsync,
    });
  };

  const handleCloseViewCheckinRegister = () => {
    attendanceHideDrawerViewRegister();
    form.resetFields();
    lobbyClearDocuments();
    lobbySaleChannelActive(null);
    lobbyCheckinUpdateRegisterActive({ checkinRegisterActive: null });
    attendanceUpdateTabpaneActive(TabPaneStatusEnum.Info);
    attendanceUpdateDrawerViewMode(DrawerStatusEnum.View);
    attendanceUpdateItemsCheckin([]);
    attendanceUpdateFormModified(false);
  };

  const handleCloseCheckinRegister = () => {
    attendanceHideDrawerCheckinRegister();
    formCheckin.resetFields();
    lobbyClearDocuments();
    lobbySaleChannelActive(null);
    attendanceUpdateDrawerViewMode(DrawerStatusEnum.View);
    attendanceUpdateFormModified(false);
  };

  const handleCloseEditCheckinRegister = () => {
    attendanceHideDrawerViewCheckinRegister();
    form.resetFields();
    lobbyCheckinClearDrivers();
    lobbySaleChannelActive(null);
    attendanceUpdateTabpaneActive(TabPaneStatusEnum.Info);
    attendanceUpdateDrawerViewMode(DrawerStatusEnum.View);
    attendanceUpdateItemsCheckin([]);
    attendanceUpdateFormModified(false);
  };

  return (
    <Layout title={TITLE_PAGE} isLoading={isLoading} role={userData.role}>
      <Summary activeSummaryData={activeSummaryData} isLoadingSummary={isLoadingSummary} isSidebarCollapsed={isCollapseSidebar}>
        <S.HeaderAttendanceContainer>
          <Register isAllowed={isAttendanceAndAdmin(userData.role)} attendanceShowDrawerCheckinRegister={attendanceShowDrawerCheckinRegister} />
          <S.SearchFieldContainer>
            <AttendanceFilter attendanceUpdateFilterTable={attendanceUpdateFilterTable} attendanceChangeFieldValue={attendanceChangeFieldValue} />
          </S.SearchFieldContainer>
        </S.HeaderAttendanceContainer>
      </Summary>
      <FilterOptions
        allProcessesList={inboundProcessesList}
        salesChannelList={salesChannelList}
        attendanceChangeFilterOptionsValue={attendanceChangeFilterOptionsValue}
        attendanceFetchRegisterAsync={attendanceFetchRegisterAsync}
        statusId={statusId}
        setStatusId={setStatusId}
        processValue={processValue}
        setProcessValue={setProcessValue}
        salesChannelvalue={salesChannelvalue}
        setSalesChannelValue={setSalesChannelValue}
        attendanceChangeFieldValue={attendanceChangeFieldValue}
        attendanceFetchSummaryAsync={attendanceFetchSummaryAsync}
        vehicleStatusList={vehicleStatusList}
      />
      <Drawers
        checkinRegisterActive={checkinRegisterActive}
        disabledButton={disabledButton}
        userData={userData}
        excludeButtonDisabled={excludeButtonDisabled}
        YES_MESSAGE={YES_MESSAGE}
        NO_MESSAGE={NO_MESSAGE}
        visibleDrawerViewMode={visibleDrawerViewMode}
        formViewOrEditModified={formViewOrEditModified}
        visibleDrawerCheckinRegisterAttendance={visibleDrawerCheckinRegisterAttendance}
        visibleFocus={visibleFocus}
        handleOnConfirmDrawerViewRegister={handleOnConfirmDrawerViewRegister}
        handleOnConfirmDrawerCheckinRegister={handleOnConfirmDrawerCheckinRegister}
        attendanceHideDrawerCheckinRegister={handleCloseCheckinRegister}
        formCheckin={formCheckin}
        inboundProcessesList={inboundProcessesList}
        lobbyDocumentsFetchAsync={lobbyDocumentsFetchAsync}
        documentsList={documentsList}
        carrierRef={carrierRef}
        lobbyProcessActive={lobbyProcessActive}
        hasSaleChannel={hasSaleChannel}
        lobbySaleChannelActive={lobbySaleChannelActive}
        salesChannelList={salesChannelList}
        visibleDrawerViewCheckinRegisterAttendance={visibleDrawerViewCheckinRegisterAttendance}
        attendanceHideDrawerViewCheckinRegister={handleCloseEditCheckinRegister}
        attendanceHideDrawerViewCheckinExclude={handleOnConfirmExcludeCheckin}
        attendanceHideDrawerVehicleEntryAuthorization={attendanceHideDrawerVehicleEntryAuthorization}
        visibleDrawerVehicleEntryAuthorization={visibleDrawerVehicleEntryAuthorization}
        vehicleEntryAuthorizationRegisterActive={vehicleEntryAuthorizationRegisterActive}
        form={form}
        attendanceHideDrawerViewRegister={handleCloseViewCheckinRegister}
        visibleDrawerViewRegisterAttendance={visibleDrawerViewRegisterAttendance}
        isConcierge={isConcierge}
        attendanceUpdateFormModified={attendanceUpdateFormModified}
        tabPaneActive={tabPaneActive}
        attendanceUpdateTabpaneActive={attendanceUpdateTabpaneActive}
        lobbyCheckinUpdateRegisterActive={lobbyCheckinUpdateRegisterActive}
        drawerIsLoading={drawerIsLoading}
        documentType={documentType}
        plateFormatType={plateFormatType}
        vehicleProfileByPlate={vehicleProfileByPlate}
        lobbyFetchVehicleProfileByPlateAsync={lobbyFetchVehicleProfileByPlateAsync}
        lobbyUpdateVehicleProfileByPlate={lobbyUpdateVehicleProfileByPlate}
        processActive={processActive}
      />
      <VehicleAction
        formVehicleActionAttendance={formVehicleActionAttendance}
        vehicleActionSelected={vehicleActionSelected}
        allowRequestDockEntryAction={allowRequestDockEntryAction}
        allowRequestVehicleInboundAction={allowRequestVehicleInboundAction}
        visibleModalVehicleAction={visibleModalVehicleAction}
        setVehicleActionSelected={setVehicleActionSelected}
        onChangeRadioVehicleAction={onChangeRadioVehicleAction}
        handleClickConfirmVehicleAction={handleClickConfirmVehicleAction}
        attendanceHideModalVehicleAction={attendanceHideModalVehicleAction}
        disabledButtonSaveVehicle={disabledButtonSaveVehicle}
      />
      <ReleaseVehicleAction
        handleClickConfirm={handleClickConfirmReleaseVehicleAction}
        visibleModal={visibleModalReleaseVehicle}
        hideModal={attendanceHideModalReleaseVehicleAction}
        vehiclePlateSelected={vehiclePlateSelected}
        disabledButton={disabledButtonReleaseVehicle}
      />
      <AttendanceGrid
        items={items}
        totalItems={totalItems}
        pageIndex={pageIndex}
        userData={userData}
        hasScheduling={hasScheduling}
        allowRequestDockEntryAction={allowRequestDockEntryAction}
        allowRequestVehicleInboundAction={allowRequestVehicleInboundAction}
        allowRequestVehicleEntryAuthorizationAction={allowRequestVehicleEntryAuthorizationAction}
        attendanceFetchRegisterAsync={attendanceFetchRegisterAsync}
        attendanceChangeFieldValue={attendanceChangeFieldValue}
        lobbyFetchItemCheckinAsync={lobbyFetchItemCheckinAsync}
        attendanceShowDrawerViewCheckinRegister={attendanceShowDrawerViewCheckinRegister}
        attendanceShowDrawerViewRegister={attendanceShowDrawerViewRegister}
        attendanceShowModalVehicleAction={attendanceShowModalVehicleAction}
        attendanceShowModalReleaseVehicleAction={attendanceShowModalReleaseVehicleAction}
        setGateEventId={setGateEventId}
        setYardRegisterId={setYardRegisterId}
        setVehiclePlateSelected={setVehiclePlateSelected}
        formVehicleActionAttendance={formVehicleActionAttendance}
        setVehicleActionSelected={setVehicleActionSelected}
        attendanceFetchItemVehicleEntryAuthorizationAsync={attendanceFetchItemVehicleEntryAuthorizationAsync}
        attendanceShowDrawerVehicleEntryAuthorization={attendanceShowDrawerVehicleEntryAuthorization}
        isLoadingTable={isLoadingTable}
        lobbyFetchItemAsync={lobbyFetchItemAsync}
      />
      <button data-testid="drawer-edit-inbound" onClick={handleOnConfirmDrawerViewRegister} style={{ display: "none" }} />
    </Layout>
  );
};

const mapDispatchToActions = (dispatch: any) => bindActionCreators({ ...UserSessionActions, ...LobbyActions, ...AttendanceActions, ...ProcessActiona }, dispatch);

const mapStateToProps = (state) => ({
  isLoading: state.Attendance.isLoading,
  disabledButtonReleaseVehicle: state.Attendance.disabledButtonReleaseVehicle,
  items: state.Attendance.items,
  totalItems: state.Attendance.totalItems,
  pageIndex: state.Attendance.filter.pageIndex,
  disabledButtonSaveVehicle: state.Attendance.disabledButtonSaveVehicle,
  hasSaleChannel: state.Lobby.hasSaleChannel,
  userData: state.UserSession.userData,
  isConcierge: state.UserSession.isConcierge,
  documentType: state.Lobby.documentType,
  documentsList: state.Lobby.documentsList,
  hasScheduling: state.Lobby.hasScheduling,
  plateFormatType: state.Lobby.plateFormatType,
  salesChannelList: state.Lobby.salesChannelList,
  inboundProcessesList: state.Lobby.inboundProcessesList,
  formViewOrEditModified: state.Attendance.formViewOrEditModified,
  visibleDrawerViewMode: state.Attendance.visibleDrawerViewMode,
  registerActive: state.Lobby.registerActive,
  allowRequestDockEntryAction: state.Lobby.allowRequestDockEntryAction,
  allowRequestVehicleInboundAction: state.Lobby.allowRequestVehicleInboundAction,
  visibleModalVehicleAction: state.Attendance.visibleModalVehicleAction,
  visibleDrawerViewCheckinRegisterAttendance: state.Attendance.visibleDrawerViewCheckinRegisterAttendance,
  visibleDrawerCheckinRegisterAttendance: state.Attendance.visibleDrawerCheckinRegisterAttendance,
  searchFilter: state.Attendance.searchFilter,
  visibleModalReleaseVehicle: state.Attendance.visibleModalReleaseVehicle,
  disabledButton: state.Attendance.disabledButton,
  allowRequestVehicleEntryAuthorizationAction: state.Lobby.allowRequestVehicleEntryAuthorizationAction,
  checkinRegisterActive: state.Lobby.checkinRegisterActive,
  processActive: state.Lobby.processActive,
  saleChannelActive: state.Lobby.saleChannelActive,
  excludeButtonDisabled: state.Attendance.excludeButtonDisabled,
  visibleDrawerVehicleEntryAuthorization: state.Attendance.visibleDrawerVehicleEntryAuthorization,
  vehicleEntryAuthorizationRegisterActive: state.Attendance.vehicleEntryAuthorizationRegisterActive,
  activeSummaryData: state.Attendance.activeSummaryData,
  isCollapseSidebar: state.UserSession.isCollapseSidebar,
  isLoadingTable: state.Attendance.filterOptions.isLoadingTable,
  isLoadingSummary: state.Attendance.isLoadingSummary,
  vehicleStatusList: state.Attendance.vehicleStatusList,
  visibleDrawerViewRegisterAttendance: state.Attendance.visibleDrawerViewRegisterAttendance,
  tabPaneActive: state.Attendance.tabPaneActive,
  drawerIsLoading: state.Lobby.drawerIsLoading,
  vehicleProfileByPlate: state.Lobby.vehicleProfileByPlate,
});

export default connect(mapStateToProps, mapDispatchToActions)(Attendance);
